import React from "react";
import { Head, ContentHelp } from "../../components";
import "./help.css";

export const Help = () => {
  return (
    <>
      <div className="help-g">
        <Head title="Contactanos" />
        <div className="help-main">
          <ContentHelp />
        </div>
      </div>
    </>
  );
};

export default Help;
